import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { CategoriesState, OtherCategory } from "./types";

let initialState: CategoriesState = {
  categories: [],
  isLoading: false,
};

const categories = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<OtherCategory[]>) {
      state.categories = action.payload;
      state.isLoading = false;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const { setCategories } = categories.actions;

export const selectCategories = (state: RootState) =>
  state.categories.categories;
export const selectCategoriesLoading = (state: RootState) =>
  state.categories.isLoading;

const mockCategories: OtherCategory[] = [
  {
    _id: "1",
    title: "Климатици",
    route: "/category",
  },
  {
    _id: "2",
    title: "Аксесоари",
    route: "/accessories",
  },
];

export const fetchCategories = () => (dispatch: any) => {
  try {
    dispatch(setCategories(mockCategories));
  } catch (error: any) {
    // log error
  }
};

export default categories.reducer;
